module.exports = __webpack_public_path__ + "img/4-1.3c4aa951.svg";